module.exports = __webpack_public_path__ + "public/images/math-background-pattern.1a1ff5ec8b05e0071c0f3ea73ff88e6c.svg";